import ProductScheduleRange from 'components/pages/PCM/Products/ProductFields/ProductScheduleRange/ProductScheduleRange';
import ProductPricingMode from '../../Products/ProductFields/ProductPricingMode/ProductPricingMode';
import ProductMediaType from '../../Products/ProductFields/ProductMediaType/ProductMediaType';
import ProductNetworks from '../../Products/ProductFields/ProductNetworks/ProductNetworks';
import { ProductFormats } from '../../Products/ProductFields/ProductFormats/ProductFormats';
import { ProductObjectives } from '../../Products/ProductFields/ProductObjectives/ProductObjectives';
import ProductChannels from '../../Products/ProductFields/ProductChannels/ProductChannels';
import { SectionWrapper } from './SectionWrapper/SectionWrapper';
import { ProductTargets } from '../../Products/ProductFields/ProductTargets/ProductTargets';
import ProductLocations from '../../Products/ProductFields/ProductLocations/ProductLocations';
import ProductFrameList from '../../Products/ProductFields/ProductFrameList/ProductFrameList';
import ProductPoi from '../../Products/ProductFields/ProductPoi/ProductPoi';
import ProductTags from '../../Products/ProductFields/ProductTags/ProductTags';
import ProductShareOfTime from '../../Products/ProductFields/ProductShareOfTime/ProductShareOfTime';
import ProductLineActions from '../ProductLineActions';

export const CreateProductContent: React.FC = () => {
  return (
    <div className="px-6 py-3 min-w-[550px]" data-test-id="create-product-content">
      <ProductLineActions />
      <SectionWrapper title="Setting:">
        <ProductPricingMode />
      </SectionWrapper>
      <SectionWrapper title="Deal line info:">
        <ProductScheduleRange />
        <ProductMediaType />
        <ProductChannels />
      </SectionWrapper>
      <SectionWrapper title="Targets:">
        <ProductTargets />
        <ProductNetworks />
        <ProductShareOfTime />
      </SectionWrapper>
      <SectionWrapper title="Filters:">
        <ProductFormats />
        <ProductLocations />
        <ProductFrameList />
        <ProductTags />
      </SectionWrapper>
      <SectionWrapper title="Data targeting:">
        <ProductPoi />
      </SectionWrapper>
      <SectionWrapper title="Objectives:">
        <ProductObjectives />
      </SectionWrapper>
    </div>
  );
};
